import Vue from 'vue';
const EventBus = new Vue();
const eventBus = {
  emit: (eventString, params = null) => EventBus.$emit(eventString, params),
  on: (eventString, action = () => {}) => EventBus.$on(eventString, action),
  off: (eventString, action = () => {}) => EventBus.$off(eventString, action)
};
export default eventBus;
